var map = {
	"./status-alert-icon.svg": 536,
	"./status-alert.svg": 537,
	"./status-not-available-icon.svg": 538,
	"./status-not-available.svg": 539,
	"./status-ok-icon.svg": 471,
	"./status-ok.svg": 540,
	"./status-unknown-icon.svg": 472,
	"./status-unknown.svg": 541,
	"./status-warn-icon.svg": 542,
	"./status-warn.svg": 543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 535;